// header 相关组件和样式
// 所有使用通用header的页面需要导入
// import "./header-common";
import Vue from "vue";
// import "@/styles/common/reset.scss";
// import "apower-ui/lib/theme-chalk/normalize.css";
// import "@/styles/common/font-face.scss";
import { Header, Button, Popover, Container, Footer, Image } from "apower-ui";
import "apower-ui/lib/theme-chalk/icon.css";
import "@/styles/components/common.scss";

// import CollapsedMenu from '@/components/CollapsedMenu/CollapsedMenu.vue'
// import PcHeaderMenu from '@/components/CollapsedMenu/PcHeaderMenu.vue'
// import HeaderAccountButton from "@/components/HeaderAccountButton.vue";
import GoogleSearch from "@/components/GoogleSearch";
import RightBar from "@/components/RightBar";
import { newHeader } from "@picwish/header";
import "@picwish/header/style.css";
import "./sceneTracing.js";

newHeader();
const components = [
  Header,
  Button,
  Popover,
  Container,
  // CollapsedMenu,
  GoogleSearch,
  // PcHeaderMenu,
  Footer,
  Image,
  RightBar,
];

components.forEach((component) => {
  Vue.component(component.name, component);
});
